import {createContext} from "react";

export interface ConfirmModalProps {
    question: string;
    signatureWanted?: boolean;
    yesAnswer: string;
    noAnswer?: string;

    onYes(sigBlob$: Promise<Blob | null>): void;
}

export const confirmModalActionButtonSx = {px: 1.6, py: 1.2, fontSize: "lg", mx: 2};

export interface ConfirmModalState {
    open(props: ConfirmModalProps): void;
}

export const ConfirmModalContext = createContext<ConfirmModalState>({
    open: () => {
        /**/
    }
});

